const root = document.querySelector<HTMLElement>('#app')!;

export default root;
